import React, { ButtonHTMLAttributes, memo } from 'react';
import Button from '@material-ui/core/Button';
import { ButtonComponentProps } from './ButtonComponent.types';
import './ButtonComponent.scss';
import { createMuiTheme } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/core/styles';

const customColorButton = (main: string, contrastText: string) =>
  createMuiTheme({
    palette: {
      primary: { main, contrastText },
    },
    typography: {
      fontSize: 16,
      button: {
        textTransform: 'none',
        fontSize: 13,
      },
    },
  });

export const ButtonComponent = memo(
  <C extends React.ElementType>(
    props: ButtonComponentProps<C> &
      Partial<ButtonHTMLAttributes<HTMLButtonElement>>
  ) => {
    const {
      arrowButton,
      buttonRef,
      children,
      className = '',
      customColor,
      color = 'primary',
      // component,
      disabled = false,
      endIcon,
      fullWidth = false,
      onClick,
      variant = 'contained',
      style,
      size = 'medium',
      startIcon,
      text,
    } = props;
    const restProps = Object.keys(props)
      .filter(key => key !== 'customColor' && key !== 'arrowButton')
      .reduce(
        (res, key) =>
          Object.assign(res, {
            [key]: props[key as keyof ButtonComponentProps<C>],
          }),
        {}
      );
    const customClassName = `${className} ${arrowButton ? 'arrow-button' : ''}`;
    if (customColor) {
      return (
        <ThemeProvider
          theme={customColorButton(customColor.background, customColor.color)}
        >
          <Button
            buttonRef={buttonRef}
            color={color}
            className={customClassName}
            disabled={disabled}
            endIcon={endIcon}
            fullWidth={fullWidth}
            style={style}
            onClick={onClick}
            variant={variant}
            size={size}
            startIcon={startIcon}
            {...restProps}
          >
            {children || text}
          </Button>
        </ThemeProvider>
      );
    }
    return (
      <Button
        className={customClassName}
        buttonRef={buttonRef}
        // component={component}
        color={color}
        disabled={disabled}
        endIcon={endIcon}
        fullWidth={fullWidth}
        style={style}
        onClick={onClick}
        variant={variant}
        size={size}
        startIcon={startIcon}
        {...restProps}
      >
        {children || text}
      </Button>
    );
  }
);

ButtonComponent.displayName = 'ButtonComponent';
ButtonComponent.whyDidYouRender = true;
